/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Attainment, DegreeProgrammeAttainment } from 'common-typescript/types';

@Component({
    selector: 'app-degree-programme-attainment-details',
    templateUrl: './degree-programme-attainment-details.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DegreeProgrammeAttainmentDetailsComponent {
    @Input() attainment: DegreeProgrammeAttainment;
    @Input() secondaryAttainments: Attainment[];
    @Input() expirationImminent: boolean;
}
